module.exports = __webpack_public_path__ + "static/media/backendlogo.0f8df8e5.svg";